
import collect from 'collect.js'
import Plus from '@/assets/icons/fontawesome/light/plus.svg?inline'
import ThumbsUp from '@/assets/icons/fontawesome/regular/thumbs-up.svg?inline'
import GlobeAmericas from '@/assets/icons/fontawesome/duotone/globe-americas.svg?inline'

export default {
  components: {
    Plus,
    ThumbsUp,
    GlobeAmericas,
  },

  layout: 'minimal',

  data() {
    return {
      time: null,
      errors: {},
      error: null,
      details: null,
      sending: false,
      markup_amont: 0,
      markup_type: 'fix',
      showRequest: null,
      showRemarks: false,
      shakeRemarks: false,
      modalCitizenship: false,
      cancellation_fee_flag: false,
      form: {
        crm_customer_id: null,
        session: null,
        hotel_id: null,
        code: null,
        rooms: [],
        title: 'Mr',
        first_name: '',
        last_name: '',
        email: '',
        // email_confirmation: '',
        subscribe: true,
        country: this.country,
        country_prefix: '1',
        phone: null,
        invoice: {
          name: null,
          tax_id: null,
          email: null,
          send: false,
        },
      },
    }
  },

  async fetch() {
    await this.$axios
      .$get(
        `/v3/session/${this.$route.query.session}/hotel/${this.$route.query.hotel_id}/results/${this.$route.query.result}`,
        {
          params: {
            hotel: true,
          },
        },
      )
      .then((response) => {
        const rooms = {}
        const requests = {}

        response.data.items.forEach((room) => {
          requests[room.roomId] = false
          rooms[room.roomId] = {
            guests: [],
            request: '',
          }

          for (let adult = 0; adult < room.pax.adults; adult++) {
            rooms[room.roomId].guests.push({
              title: 'Mr',
              first_name: '',
              last_name: '',
            })
          }

          for (let child = 0; child < room.pax.children.length; child++) {
            rooms[room.roomId].guests.push({
              title: 'Child',
              first_name: '',
              last_name: '',
              age: room.pax.children[child],
            })
          }
        })

        this.details = response
        this.showRequest = requests
        this.time = this.$moment
          .utc(response.created_at)
          .add(this.$config.sessionLifetime, 'minutes')
          .diff(this.$moment.utc(), 'millisecond')
        if (
          this.$route.query.type === 'fix' ||
          this.$route.query.type === 'percentage'
        ) {
          this.markup_amont = this.$route.query.value ?? 0
          this.markup_type = this.$route.query.type
        }
        this.markup_amont = this.details.data.client_price.markup ?? 0
        this.form = {
          crm_customer_id: this.$route.query.crm_customer_id,
          session: this.$route.query.session,
          hotel_id: this.$route.query.hotel_id,
          code: this.$route.query.result,
          rooms,
          title: 'Mr',
          first_name: '',
          last_name: '',
          email: '',
          // email_confirmation: '',
          subscribe: true,
          country: this.country,
          country_prefix: this.currentCountry.dial_code,
          phone: null,
          invoice: {
            name: null,
            tax_id: null,
            email: null,
            send: false,
          },
          markup: 0,
          total_price: this.details.data.price.amount,
          cancellation_fee: 0,
          terms: false,
          remarks: false,
          agent_approval: false,
          fid: this.getFid,
          reference: this.isAgent ? this.authUser.id : null,
          agent_voucher: false,
        }
      })
      .catch((error) => {
        if (
          typeof error.response.data === 'object' &&
          error.response.data.errors?.session
        ) {
          this.error = error.response.data
        }
      })
  },

  head() {
    return {
      title: this.$i18n.t('Your Details'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('Your Details'),
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.$i18n.t('Your Details'),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$i18n.t('Your Details'),
        },
      ],
    }
  },
  computed: {
    prefixes() {
      return collect(this.countries).sortBy('dial_code').all()
    },
    citizenships() {
      return collect(this.countries)
        .transform((item) => {
          item.citizenship = item.translations[this.$i18n.locale]
            ? item.translations[this.$i18n.locale].title
            : item.name

          return item
        })
        .sortBy('citizenship')
        .all()
    },
    currentCountry() {
      const current = this.countries.find((c) => c.code === this.country)

      if (current) {
        return current
      }

      return this.countries.find((c) => c.code === 'US')
    },
    query() {
      return collect(this.details.search)
        .only([
          'check_in',
          'check_out',
          'guests',
          'currency',
          'radius',
          'latitude',
          'longitude',
        ])
        .all()
    },
    hasChildren() {
      return this.details.data.items.some((room) => room.pax.children.length)
    },
  },

  watch: {
    markup_amont() {
      if (this.markup_type === 'fix' && this.markup_amont > 0) {
        this.form.markup = Number(this.markup_amont)
      } else if (this.markup_type === 'percentage' && this.markup_amont > 0) {
        this.form.markup = Number(
          this.details.data.price.amount * (this.markup_amont / 100),
        )
      } else {
        this.form.markup = Number(0)
      }
    },
    markup_type() {
      if (this.markup_type === 'fix' && this.markup_amont > 0) {
        this.form.markup = Number(this.markup_amont)
      } else if (this.markup_type === 'percentage' && this.markup_amont > 0) {
        this.form.markup = Number(
          this.details.data.price.amount * (this.markup_amont / 100),
        )
      } else {
        this.form.markup = Number(0)
      }
    },

    form: {
      deep: true,
      // immediate: true,

      handler(newForm, oldForm) {
        // this.form.country = this.country

        if (this.details && this.details.data) {
          this.form.first_name =
            newForm.rooms[
              this.details.data.items[0].roomId
            ].guests[0].first_name
          this.form.last_name =
            newForm.rooms[this.details.data.items[0].roomId].guests[0].last_name

          this.details.data.items.forEach((item) => {
            const room = newForm.rooms[item.roomId]

            room.guests.forEach((guest) => {
              guest.name = (
                room.guests[0].first_name +
                ' ' +
                room.guests[0].last_name
              ).trim() // @temp
              guest.first_name = room.guests[0].first_name
              guest.last_name = room.guests[0].last_name
            })
          })
        }

        if (
          newForm.invoice.send &&
          newForm.invoice.name === null &&
          newForm.invoice.email === null &&
          newForm.invoice.tax_id === null &&
          (newForm.first_name || newForm.last_name)
        ) {
          this.form.invoice.name = (
            newForm.first_name +
            ' ' +
            newForm.last_name
          ).trim()
          this.form.invoice.email = newForm.email
        }

        if (newForm.country !== this.country) {
          this.modalCitizenship = true
        }
      },
    },
  },

  mounted() {
    this.form.country = this.country
    this.form.country_prefix = this.currentCountry.dial_code
    if (this.isAgent) {
      this.form.reference = this.authUser.id
    }
  },

  methods: {
    revertCountry() {
      this.form.country = this.country
      this.modalCitizenship = false
    },
    changeCountry() {
      if (!this.details) {
        return null
      }

      this.setCountry(this.form.country)

      if (this.details.data.hotel.aggregator === 'innstant') {
        this.$router.replace(
          this.localePath({
            name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
            params: {
              countrySlug: this.details.data.hotel.destinations[0].country.slug,
              destinationSlug: this.details.data.hotel.destinations[0].slug,
              hotelSlug: this.details.data.hotel.slug,
            },
            query: this.query,
          }),
        )
      } else {
        this.$router.replace(
          this.localePath({
            name: 'hotels-place-countrySlug-hotelId',
            params: {
              countrySlug: this.details.data.hotel.country.slug,
              hotelId: this.details.data.hotel.id,
            },
            query: this.query,
          }),
        )
      }
    },
    goToRemarks() {
      const el = document.getElementById('remarksSection')

      if (el) {
        el.scrollIntoView()
      }

      this.showRemarks = true
      this.shakeRemarks = true

      setTimeout(() => {
        this.shakeRemarks = false
      }, 1000)
    },
    async book() {
      this.validateEmail()
      if (this.errors.email.length) {
        return
      }

      this.errors = null
      this.sending = true

      try {
        await this.$axios
          .post('/v3/reservations', this.form)
          .then((response) => {
            this.$router.push(
              this.localePath({
                name: 'pay',
                query: { reservation: response.data.data.uuid },
              }),
            )
          })
          .catch((error) => {
            if (typeof error.response.data === 'object') {
              this.errors = error.response.data.errors

              if (error.response.data.errors.session) {
                this.error = error.response.data
              }
            } else {
              this.errors = {
                message: 'Something went wrong. Please try again.',
              }
            }
          })
      } catch (err) {
        // this.$sentry.captureException(err)
      }

      this.sending = false
    },
    validateFirstName(roomId) {
      this.errors = JSON.parse(JSON.stringify(this.errors))

      const reg = /^[a-zA-Z0-9(-_'-.\r\n !]+$/

      this.form.rooms[roomId].guests.forEach((guest) => {
        if (!guest.first_name) {
          this.errors[`rooms.${roomId}.guests.${0}.first_name`] = [
            this.$i18n.t('Please enter a first name'),
          ]
        } else if (!reg.test(guest.first_name)) {
          this.errors[`rooms.${roomId}.guests.${0}.first_name`] = [
            this.$i18n.t('Please enter only English characters'),
          ]
        } else {
          this.errors[`rooms.${roomId}.guests.${0}.first_name`] = []
        }
      })
    },
    validateLastName(roomId) {
      this.errors = JSON.parse(JSON.stringify(this.errors))

      const reg = /^[a-zA-Z0-9(-_'-.\r\n !]+$/

      this.form.rooms[roomId].guests.forEach((guest) => {
        if (!guest.first_name) {
          this.errors[`rooms.${roomId}.guests.${0}.last_name`] = [
            this.$i18n.t('Please enter a last name'),
          ]
        } else if (!reg.test(guest.first_name)) {
          this.errors[`rooms.${roomId}.guests.${0}.last_name`] = [
            this.$i18n.t('Please enter only English characters'),
          ]
        } else {
          this.errors[`rooms.${roomId}.guests.${0}.last_name`] = []
        }
      })
    },
    validatePhone() {
      this.errors = JSON.parse(JSON.stringify(this.errors))

      if (!this.form.phone) {
        this.errors.phone = [this.$i18n.t('Please enter a phone')]
      } else {
        this.errors.phone = []
      }
    },
    validateEmail() {
      this.errors = JSON.parse(JSON.stringify(this.errors || {}))

      // Strip invisible bidi/zero-width chars (common when pasting from RTL text) and whitespace
      if (this.form.email) {
        this.form.email = this.form.email
          .replace(/[\u200B-\u200F\u202A-\u202E\u2060\u2066-\u2069\uFEFF]/g, '')
          .trim()
      }

      const reg = /^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

      if (!this.form.email) {
        this.errors.email = [this.$i18n.t('Please enter an email address')]
      } else if (!reg.test(this.form.email)) {
        this.errors.email = [this.$i18n.t('Please enter a valid email address')]
      } else {
        this.errors.email = []
      }
    },
    // validateEmailConfirmaton () {
    //   this.errors = JSON.parse(JSON.stringify(this.errors))

    //   if (!this.form.email_confirmation) {
    //     this.errors.email_confirmation = [this.$i18n.t('Please enter a valid email address')]
    //   } else if (this.form.email_confirmation !== this.form.email) {
    //     this.errors.email_confirmation = [this.$i18n.t('The email confirmation does not match')]
    //   } else {
    //     this.errors.email_confirmation = []
    //   }
    // },
    validateSpecialRequest(roomId) {
      this.errors = JSON.parse(JSON.stringify(this.errors))

      const reg = /^[a-zA-Z0-9(-_'-.\r\n !]+$/

      if (!reg.test(this.form.rooms[roomId].request)) {
        this.errors[`rooms.${roomId}.request`] = [
          this.$i18n.t('Please enter only English characters'),
        ]
      } else {
        this.errors[`rooms.${roomId}.request`] = []
      }
    },
    validateCancellationFee() {
      this.errors = JSON.parse(JSON.stringify(this.errors))

      if (this.form.cancellation_fee > this.details.data.price.amount) {
        this.errors.cancellation_fee = [
          this.$i18n.t('Cannot be more then total price'),
        ]
      } else {
        this.errors.cancellation_fee = []
      }
    },
  },
}
